// CLAP struct offsets on wasm32 (ILP32): 4-byte pointers, 8-byte aligned doubles and i64
export var ClapAbi;
(function (ClapAbi) {
    ClapAbi.VERSION = { major: 1, minor: 2, revision: 2 };
    ClapAbi.INVALID_ID = 0xFFFFFFFF;
    let PluginEntry;
    (function (PluginEntry) {
        PluginEntry.INIT = 12;
        PluginEntry.DEINIT = 16;
        PluginEntry.GET_FACTORY = 20;
    })(PluginEntry = ClapAbi.PluginEntry || (ClapAbi.PluginEntry = {}));
    let PluginFactory;
    (function (PluginFactory) {
        PluginFactory.ID = "clap.plugin-factory";
        PluginFactory.GET_PLUGIN_COUNT = 0;
        PluginFactory.GET_PLUGIN_DESCRIPTOR = 4;
        PluginFactory.CREATE_PLUGIN = 8;
    })(PluginFactory = ClapAbi.PluginFactory || (ClapAbi.PluginFactory = {}));
    let PluginDescriptor;
    (function (PluginDescriptor) {
        PluginDescriptor.ID = 12;
        PluginDescriptor.NAME = 16;
        PluginDescriptor.VENDOR = 20;
        PluginDescriptor.VERSION = 36;
        PluginDescriptor.FEATURES = 44;
    })(PluginDescriptor = ClapAbi.PluginDescriptor || (ClapAbi.PluginDescriptor = {}));
    let Host;
    (function (Host) {
        Host.SIZE = 48;
        Host.HOST_DATA = 12;
        Host.NAME = 16;
        Host.VENDOR = 20;
        Host.URL = 24;
        Host.VERSION = 28;
        Host.GET_EXTENSION = 32;
        Host.REQUEST_RESTART = 36;
        Host.REQUEST_PROCESS = 40;
        Host.REQUEST_CALLBACK = 44;
    })(Host = ClapAbi.Host || (ClapAbi.Host = {}));
    let Plugin;
    (function (Plugin) {
        Plugin.INIT = 8;
        Plugin.DESTROY = 12;
        Plugin.ACTIVATE = 16;
        Plugin.DEACTIVATE = 20;
        Plugin.START_PROCESSING = 24;
        Plugin.STOP_PROCESSING = 28;
        Plugin.RESET = 32;
        Plugin.PROCESS = 36;
        Plugin.GET_EXTENSION = 40;
        Plugin.ON_MAIN_THREAD = 44;
    })(Plugin = ClapAbi.Plugin || (ClapAbi.Plugin = {}));
    let Process;
    (function (Process) {
        Process.SIZE = 40;
        Process.STEADY_TIME = 0;
        Process.FRAMES_COUNT = 8;
        Process.TRANSPORT = 12;
        Process.AUDIO_INPUTS = 16;
        Process.AUDIO_OUTPUTS = 20;
        Process.AUDIO_INPUTS_COUNT = 24;
        Process.AUDIO_OUTPUTS_COUNT = 28;
        Process.IN_EVENTS = 32;
        Process.OUT_EVENTS = 36;
    })(Process = ClapAbi.Process || (ClapAbi.Process = {}));
    let AudioBuffer;
    (function (AudioBuffer) {
        AudioBuffer.SIZE = 24;
        AudioBuffer.DATA32 = 0;
        AudioBuffer.DATA64 = 4;
        AudioBuffer.CHANNEL_COUNT = 8;
        AudioBuffer.LATENCY = 12;
        AudioBuffer.CONSTANT_MASK = 16;
    })(AudioBuffer = ClapAbi.AudioBuffer || (ClapAbi.AudioBuffer = {}));
    let InputEvents;
    (function (InputEvents) {
        InputEvents.SIZE = 12;
        InputEvents.CTX = 0;
        InputEvents.SIZE_FN = 4;
        InputEvents.GET_FN = 8;
    })(InputEvents = ClapAbi.InputEvents || (ClapAbi.InputEvents = {}));
    let OutputEvents;
    (function (OutputEvents) {
        OutputEvents.SIZE = 8;
        OutputEvents.CTX = 0;
        OutputEvents.TRY_PUSH_FN = 4;
    })(OutputEvents = ClapAbi.OutputEvents || (ClapAbi.OutputEvents = {}));
    let EventHeader;
    (function (EventHeader) {
        EventHeader.SIZE = 16;
        EventHeader.TIME = 4;
        EventHeader.SPACE_ID = 8;
        EventHeader.TYPE = 10;
        EventHeader.FLAGS = 12;
    })(EventHeader = ClapAbi.EventHeader || (ClapAbi.EventHeader = {}));
    let EventType;
    (function (EventType) {
        EventType.NOTE_ON = 0;
        EventType.NOTE_OFF = 1;
        EventType.NOTE_CHOKE = 2;
        EventType.PARAM_VALUE = 5;
        EventType.PARAM_MOD = 6;
        EventType.PARAM_GESTURE_BEGIN = 7;
        EventType.PARAM_GESTURE_END = 8;
        EventType.TRANSPORT = 9;
    })(EventType = ClapAbi.EventType || (ClapAbi.EventType = {}));
    let NoteEvent;
    (function (NoteEvent) {
        NoteEvent.SIZE = 40;
        NoteEvent.NOTE_ID = 16;
        NoteEvent.PORT_INDEX = 20;
        NoteEvent.CHANNEL = 22;
        NoteEvent.KEY = 24;
        NoteEvent.VELOCITY = 32;
    })(NoteEvent = ClapAbi.NoteEvent || (ClapAbi.NoteEvent = {}));
    let ParamValueEvent;
    (function (ParamValueEvent) {
        ParamValueEvent.SIZE = 48;
        ParamValueEvent.PARAM_ID = 16;
        ParamValueEvent.COOKIE = 20;
        ParamValueEvent.NOTE_ID = 24;
        ParamValueEvent.PORT_INDEX = 28;
        ParamValueEvent.CHANNEL = 30;
        ParamValueEvent.KEY = 32;
        ParamValueEvent.VALUE = 40;
    })(ParamValueEvent = ClapAbi.ParamValueEvent || (ClapAbi.ParamValueEvent = {}));
    let Ext;
    (function (Ext) {
        Ext.GUI = "clap.gui";
        Ext.AUDIO_PORTS = "clap.audio-ports";
        Ext.PARAMS = "clap.params";
        Ext.STATE = "clap.state";
        Ext.WEBVIEW = "clap.webview/3";
        Ext.LOG = "clap.log";
        Ext.THREAD_CHECK = "clap.thread-check";
        Ext.PARAM_HOVERED = "clap.param-hovered/1";
        Ext.HOST_PARAMS = "clap.params";
    })(Ext = ClapAbi.Ext || (ClapAbi.Ext = {}));
    let AudioPorts;
    (function (AudioPorts) {
        AudioPorts.COUNT = 0;
        AudioPorts.GET = 4;
    })(AudioPorts = ClapAbi.AudioPorts || (ClapAbi.AudioPorts = {}));
    let AudioPortInfo;
    (function (AudioPortInfo) {
        AudioPortInfo.SIZE = 276;
        AudioPortInfo.NAME = 4;
        AudioPortInfo.CHANNEL_COUNT = 264;
    })(AudioPortInfo = ClapAbi.AudioPortInfo || (ClapAbi.AudioPortInfo = {}));
    let Params;
    (function (Params) {
        Params.COUNT = 0;
        Params.GET_INFO = 4;
        Params.GET_VALUE = 8;
        Params.VALUE_TO_TEXT = 12;
        Params.TEXT_TO_VALUE = 16;
        Params.FLUSH = 20;
    })(Params = ClapAbi.Params || (ClapAbi.Params = {}));
    let ParamFlags;
    (function (ParamFlags) {
        ParamFlags.IS_STEPPED = 1 << 0;
        ParamFlags.IS_HIDDEN = 1 << 2;
        ParamFlags.IS_READONLY = 1 << 3;
        ParamFlags.IS_AUTOMATABLE = 1 << 5;
        ParamFlags.IS_MODULATABLE = 1 << 10;
        ParamFlags.IS_ENUM = 1 << 16;
    })(ParamFlags = ClapAbi.ParamFlags || (ClapAbi.ParamFlags = {}));
    let ParamInfo;
    (function (ParamInfo) {
        ParamInfo.SIZE = 1320;
        ParamInfo.ID = 0;
        ParamInfo.FLAGS = 4;
        ParamInfo.NAME = 12;
        ParamInfo.MODULE = 268;
        ParamInfo.MIN_VALUE = 1296;
        ParamInfo.MAX_VALUE = 1304;
        ParamInfo.DEFAULT_VALUE = 1312;
    })(ParamInfo = ClapAbi.ParamInfo || (ClapAbi.ParamInfo = {}));
    let Gui;
    (function (Gui) {
        Gui.WINDOW_API_WEBVIEW = "webview";
        Gui.IS_API_SUPPORTED = 0;
        Gui.CREATE = 8;
        Gui.DESTROY = 12;
        Gui.GET_SIZE = 20;
        Gui.CAN_RESIZE = 24;
        Gui.GET_RESIZE_HINTS = 28;
        Gui.ADJUST_SIZE = 32;
        Gui.SET_SIZE = 36;
        Gui.SET_PARENT = 40;
        Gui.SHOW = 52;
        Gui.HIDE = 56;
    })(Gui = ClapAbi.Gui || (ClapAbi.Gui = {}));
    // clap_gui_resize_hints: three bools, then the aspect ratio as two u32
    let ResizeHints;
    (function (ResizeHints) {
        ResizeHints.SIZE = 12;
        ResizeHints.PRESERVE_ASPECT_RATIO = 2;
        ResizeHints.ASPECT_RATIO_WIDTH = 4;
        ResizeHints.ASPECT_RATIO_HEIGHT = 8;
    })(ResizeHints = ClapAbi.ResizeHints || (ClapAbi.ResizeHints = {}));
    // clap_window: api string pointer, then the native handle (NULL for a webview)
    let Window;
    (function (Window) {
        Window.SIZE = 8;
        Window.API = 0;
        Window.PTR = 4;
    })(Window = ClapAbi.Window || (ClapAbi.Window = {}));
    let State;
    (function (State) {
        State.SAVE = 0;
        State.LOAD = 4;
    })(State = ClapAbi.State || (ClapAbi.State = {}));
    let HostState;
    (function (HostState) {
        HostState.SIZE = 4;
        HostState.MARK_DIRTY = 0;
    })(HostState = ClapAbi.HostState || (ClapAbi.HostState = {}));
    // clap_istream / clap_ostream: ctx, then read/write(stream, buffer, u64 size) -> i64
    let Stream;
    (function (Stream) {
        Stream.SIZE = 8;
        Stream.CTX = 0;
        Stream.FN = 4;
    })(Stream = ClapAbi.Stream || (ClapAbi.Stream = {}));
    let Webview;
    (function (Webview) {
        Webview.GET_URI = 0;
        Webview.GET_RESOURCE = 4;
        Webview.RECEIVE = 8;
    })(Webview = ClapAbi.Webview || (ClapAbi.Webview = {}));
    let HostWebview;
    (function (HostWebview) {
        HostWebview.SIZE = 4;
        HostWebview.SEND = 0;
    })(HostWebview = ClapAbi.HostWebview || (ClapAbi.HostWebview = {}));
    let HostLog;
    (function (HostLog) {
        HostLog.SIZE = 4;
        HostLog.LOG = 0;
    })(HostLog = ClapAbi.HostLog || (ClapAbi.HostLog = {}));
    let HostParams;
    (function (HostParams) {
        HostParams.SIZE = 12;
        HostParams.RESCAN = 0;
        HostParams.CLEAR = 4;
        HostParams.REQUEST_FLUSH = 8;
    })(HostParams = ClapAbi.HostParams || (ClapAbi.HostParams = {}));
    // clap_event_transport, i64/f64 fields 8-aligned after the 16-byte header + flags
    let TransportEvent;
    (function (TransportEvent) {
        TransportEvent.SIZE = 104;
        TransportEvent.FLAGS = 16;
        TransportEvent.SONG_POS_BEATS = 24;
        TransportEvent.SONG_POS_SECONDS = 32;
        TransportEvent.TEMPO = 40;
        TransportEvent.TEMPO_INC = 48;
        TransportEvent.LOOP_START_BEATS = 56;
        TransportEvent.LOOP_END_BEATS = 64;
        TransportEvent.LOOP_START_SECONDS = 72;
        TransportEvent.LOOP_END_SECONDS = 80;
        TransportEvent.BAR_START = 88;
        TransportEvent.BAR_NUMBER = 96;
        TransportEvent.TSIG_NUM = 100;
        TransportEvent.TSIG_DENOM = 102;
        TransportEvent.HAS_TEMPO = 1 << 0;
        TransportEvent.HAS_BEATS_TIMELINE = 1 << 1;
        TransportEvent.IS_PLAYING = 1 << 4;
        TransportEvent.BEATTIME_FACTOR = 2 ** 31;
    })(TransportEvent = ClapAbi.TransportEvent || (ClapAbi.TransportEvent = {}));
    let HostGui;
    (function (HostGui) {
        HostGui.SIZE = 20;
        HostGui.RESIZE_HINTS_CHANGED = 0;
        HostGui.REQUEST_RESIZE = 4;
        HostGui.REQUEST_SHOW = 8;
        HostGui.REQUEST_HIDE = 12;
        HostGui.CLOSED = 16;
    })(HostGui = ClapAbi.HostGui || (ClapAbi.HostGui = {}));
    let HostParamHovered;
    (function (HostParamHovered) {
        HostParamHovered.SIZE = 4;
        HostParamHovered.UPDATE = 0;
    })(HostParamHovered = ClapAbi.HostParamHovered || (ClapAbi.HostParamHovered = {}));
    let HostThreadCheck;
    (function (HostThreadCheck) {
        HostThreadCheck.SIZE = 8;
        HostThreadCheck.IS_MAIN_THREAD = 0;
        HostThreadCheck.IS_AUDIO_THREAD = 4;
    })(HostThreadCheck = ClapAbi.HostThreadCheck || (ClapAbi.HostThreadCheck = {}));
})(ClapAbi || (ClapAbi = {}));
